import React from 'react';
import './Footer.css';

const Footer = ({ setRoute }) => {
  const year = new Date().getFullYear();

  const handleNavClick = (route) => {
    if (setRoute) {
      setRoute(route);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-section-title">Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => handleNavClick('home')} className="footer-link">Home</button></li>
              <li><button onClick={() => handleNavClick('products')} className="footer-link">Shop</button></li>
              <li><button onClick={() => handleNavClick('recipes')} className="footer-link">Recipes</button></li>
              <li><button onClick={() => handleNavClick('about')} className="footer-link">About Us</button></li>
              <li><button onClick={() => handleNavClick('contact')} className="footer-link">Contact</button></li>
              <li><button onClick={() => handleNavClick('privacy')} className="footer-link">Privacy Policy</button></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="footer-section">
            <h4 className="footer-section-title">Contact Us</h4>
            <div className="footer-contact-info">
              <a href="mailto:Rfloyd@kajunkitchen.net" className="footer-email">Rfloyd@kajunkitchen.net</a>
            </div>
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="footer-bottom">
          <div className="footer-brand-copyright">
            <div className="footer-brand-info">
              <div className="footer-brand-name">Kajun Kitchen</div>
              <div className="footer-brand-tagline">Authentic Kajun Seasonings</div>
              <div className="footer-brand-desc">Handcrafted spice blends that bring Louisiana tradition to your kitchen.</div>
            </div>
            <div className="footer-copyright">© {year} Kajun Kitchen. All Rights Reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
